import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ActionButton } from '@/features/campaigns/v2/Whatsapp/ActionButton';
import { stripTopicPrefix } from '../../templates/topicPrefix';
import type { WorkspaceTemplateRow } from '../../templates/partitionWorkspaceTemplates';
import { ChannelIndicator } from './ChannelIndicator';

type CustomModelRowProps = {
  row: WorkspaceTemplateRow;
  onPreview: (row: WorkspaceTemplateRow) => void;
  onEdit: (row: WorkspaceTemplateRow) => void;
  onDelete: (row: WorkspaceTemplateRow) => void;
};

/** Workspace template attached to a topic group — Preview / Edit / Delete. */
export const CustomModelRow: FC<CustomModelRowProps> = ({ row, onPreview, onEdit, onDelete }) => {
  const { t } = useTranslation('comuni');

  return (
    <li className='grid grid-cols-[minmax(0,1.2fr)_auto_minmax(0,2fr)_minmax(7rem,auto)_auto] items-center gap-3 px-4 py-3 max-md:grid-cols-1 max-md:gap-2'>
      <span className='truncate font-semibold'>{stripTopicPrefix(row.name)}</span>
      <ChannelIndicator channel={row.channel} />
      <p className='truncate text-sm text-tertiary-600'>{row.detail}</p>
      <div className='min-h-5' />
      <div className='flex flex-none items-center gap-3'>
        <button type='button' onClick={() => onPreview(row)} className='text-sm font-semibold text-brand-700 hover:text-brand-800'>
          {t('modelli.preview')}
        </button>
        <ActionButton onEdit={() => onEdit(row)} onDelete={() => onDelete(row)} />
      </div>
    </li>
  );
};
